module.exports = __webpack_public_path__ + "img/5.0d8842e3.png";